var map = {
	"./alibaba.js": 17620,
	"./fxg.js": 52163,
	"./index.js": 67112,
	"./jd.js": 37552,
	"./jdms.js": 15296,
	"./ktt.js": 85565,
	"./kuaishou.js": 84747,
	"./mt.js": 5827,
	"./pdd.js": 21260,
	"./shein.js": 89093,
	"./shopGoods.js": 83782,
	"./tb.js": 70568,
	"./temu.js": 65279,
	"./tjb.js": 24568,
	"./tm.js": 49749,
	"./wd.js": 65929,
	"./wxh.js": 74681,
	"./wxxd.js": 2537,
	"./xhs.js": 89885,
	"./xianyu.js": 83544,
	"./yz.js": 28661
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__(id);
});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 59658;
module.exports = webpackAsyncContext;